import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { OtpProvider } from "../contexts/OtpContext";
import { DialogProvider } from "../contexts/DialogContext";

export const OtpComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<OtpProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default OtpComposer;
